import {
  CheckMetadata,
  createSimpleCheckMetadataArray,
} from 'dashboard/components/ChecksTable/computeCheckMetadata';
import AsyncImage from 'dashboard/components-lib/AsyncImage';

export const computeIdDoubleSideDetectionMetadata = (
  frontPhotoUrl: string | undefined,
  backPhotoUrl: string | undefined,
): CheckMetadata => {
  const metadata = [];

  if (frontPhotoUrl) {
    metadata.push({
      label: 'Front',
      value: <AsyncImage value={[{ url: frontPhotoUrl }]} width='400px' height='250px' />,
    });
  }

  if (backPhotoUrl) {
    metadata.push({
      label: 'Back',
      value: <AsyncImage value={[{ url: backPhotoUrl }]} width='400px' height='250px' />,
    });
  }

  return {
    metadata: createSimpleCheckMetadataArray(metadata),
    hideIfVerificationPassed: false,
  };
};
